export default __webpack_public_path__ + "static/media/rainbow-trout.c29b0d8f.jpg";